﻿import { LanguageSelector } from '../';
export class MegaMenuNavigation {
    /**
     * Creates a new instance of the MegaMenu Class
     * @param {HTMLElement} element MainNavigation DOM Element
     */
    
    constructor(element) {
        this._refs = {
            el: element,
            toggleButton: element.querySelector(".menu-toggle"),
            megaMenu: element.querySelector(".mega-menu-new"),
            serviceMenu: element.querySelector(".service-menu-new"),
            firstLevel: [...element.querySelectorAll(".firstLevel")],
            firstLevelClick: [...element.querySelectorAll(".mega-menu-new__firstLevel")],
            languageSelector: element.querySelector('.language-selector'),
            subMenu: [...element.querySelectorAll(".subMenu")],
            headerTop: element.querySelector(".top-header-wrapper"),
            navbarWrapper: element.querySelector(".navbar-wrapper"),
            logo: element.querySelector(".logo"),
            userMenu: element.querySelector(".user-menu"),
            uipLink: element.querySelector(".UipSignInLink"),
            uipButton: element.querySelector(".UipSignInButton")
        };

        this._init();
    }

    _init() {
        this._watchFirstLevel();
        this._watchMobileToggle();
        this._watchClickOutsideMenu();
        this._createLanguageSelecor();
        this._setUipLinkLogin();
    }

    _watchFirstLevel() {
        // TODO: refactor
        //adding click event on all menu first level

        const megaMenuPrimaryLinks = document.querySelectorAll('.mega-menu__primary-link')

        megaMenuPrimaryLinks?.forEach((el) => {
            const icon = el.querySelector('.mega-menu-new__primary-link-icon')
            if(icon) {
                const descTextWrapper = el.querySelector('.mega-menu__primary-link__des')
				if(descTextWrapper !=null)
                descTextWrapper.classList.add('with-icon')
            }
        })

        if (this._refs.firstLevelClick.length > 0) {
            for (let i = 0; i < this._refs.firstLevelClick.length; i++) {
                this._refs.firstLevelClick[i].addEventListener('click', () => this._toggleActiveMenu.bind(this)(i));         
            }
        }   
    }

    _toggleActiveMenu(i) {
        if (this._refs.firstLevelClick[i].nextElementSibling != null)
        {
            this._deactiveAll(i);
            this._refs.firstLevelClick[i].parentElement.classList.toggle('active');
            this._refs.firstLevelClick[i].classList.toggle('opened');
            this._refs.firstLevelClick[i].nextElementSibling.classList.toggle('active');
            this._refs.firstLevelClick[i].querySelector('.submenu-open').classList.toggle('open-icon');
            this._refs.firstLevelClick[i].querySelector('.submenu-open').classList.toggle('arrow');
            this._refs.firstLevelClick[i].querySelector('.submenu-open').classList.toggle('show');
            this._toggleActive(i);
        }
    }

    _watchMobileToggle() {
        // TODO: Refactor
        this._refs.toggleButton.addEventListener('click', () => {
            this._refs.toggleButton.classList.toggle('nav-open');
            this._refs.el.querySelector('.navbar').classList.toggle('active');
            this._refs.megaMenu.classList.toggle('active');
            if (this._refs.serviceMenu != null) { this._refs.serviceMenu.classList.toggle('active'); }
            this._refs.logo.classList.toggle('content-hide');
            if (this._refs.userMenu != null) { this._refs.userMenu.classList.toggle('content-hide'); }
        });
    }

    _createLanguageSelecor() {
        // Language selector
        if (this._refs.languageSelector) {
            new LanguageSelector(this._refs.languageSelector);
        }
    }

    _deactiveAll(cnt) {
        const clearFirstMenu = this._refs.firstLevelClick.filter((elem, index) => index != cnt);
        for(let menu of clearFirstMenu) {
            menu.parentElement.classList.remove('active');
            menu.nextElementSibling.classList.remove('active');
            menu.classList.remove('opened');
        }
    }

    _watchClickOutsideMenu() {
        const onClick = (e) => {
            const isActive = e.target.classList.contains('backdrop');
            const elementPosition = this._refs.el.dataset.elementPosition;
            if(!isActive || !elementPosition) return;
            this._toggleActiveMenu(elementPosition);
        }
        const mainMenu = document.querySelector('.mega-menu-navigation');
        if(!mainMenu) return;
        mainMenu.addEventListener('click', onClick.bind(this));
    }

    _toggleActive(i) {
        const activeFirstLevel = [...this._refs.el.querySelectorAll('.firstLevel.active')];
        if(activeFirstLevel.length === 0) {
            this._refs.el.classList.remove('backdrop');
            this._refs.el.removeAttribute('data-element-position', i);
            return false;
        }
        this._refs.el.classList.add('backdrop');
        this._refs.el.setAttribute('data-element-position', i);
        return true;
    }

    _setUipLinkLogin() {
                
        if (this._refs.uipLink != null) {

            this._refs.uipLink.addEventListener('click', this._onClickPostback.bind(this) )

        }

    }
    _onClickPostback() {

        this._refs.uipButton.click();

    }
}